/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useRef, useState} from 'react';
import { Table, Space, Modal, message } from 'antd';
import SPButton from 'components/carRental/base/SPButton';
import type { TableProps } from 'antd';
import { TablePaginationConfig } from 'antd/lib/table';
import moment from 'moment';
import request from '../../../../request';
import { encryptTextByAES, decryptTextByAES } from '../../../../utils/encryption';
import {
	API_VEHICLE_LIST,
	API_VEHICLE_DETAIL,
	API_VEHICLE_EDIT_STATUS,
	API_VEHICLE_DELETE,
} from '../../../../hooks/carRental/_';
import emiter, {
	EVENT_VEHICLE_SEARCH_LIST,
	EVENT_VEHICLE_ADD_CAR,
	EVENT_VEHICLE_BATCH_UPLOAD,
	EVENT_VEHICLE_EXCHANGE_STORE,
	EVENT_VEHICLE_EDIT_CAR,
	EVENT_VEHICLE_VIEW_CAR,
	EVENT_VEHICLE_RESEARCH,
	EVENT_VEHICLE_TYPE,
} from '../../../../events';

import SPContentWrap from 'components/carRental/base/SPContentWrap';
import _ from 'lodash';
import {DEFAULT_PAGE_INFO} from "../../../../consts";

interface ActionBarPropsType {
	permission?: any;
}

const SPVehicleActionBar: React.FC<ActionBarPropsType> = props => {
	const { permission } = props;
	const uploadButtonText = '上传车辆';
	const batchUploadButtonText = '批量上传';

	// 上传车辆
	const uploadCarInfo = () => {
		emiter.emit(EVENT_VEHICLE_ADD_CAR);
		emiter.emit(EVENT_VEHICLE_TYPE, 'new');
	};

	// // 批量上传弹窗打开
	const batchUpload = () => {
		emiter.emit(EVENT_VEHICLE_BATCH_UPLOAD);
	};

	return (
		<Space>
			<SPButton permissionKey="veh_add" permission={permission} type="primary" onClick={uploadCarInfo}>
				{uploadButtonText}
			</SPButton>
			<SPButton permissionKey="veh_batch_add" permission={permission} type="primary" onClick={batchUpload}>
				{batchUploadButtonText}
			</SPButton>
		</Space>
	);
};

interface TableActionBarPropsType {
	data?: any;
	permission?: any;
}

const SPVehicleTableActionBar: React.FC<TableActionBarPropsType> = props => {
	const { data, permission } = props;

	const exchangeStore = () => {
		emiter.emit(EVENT_VEHICLE_EXCHANGE_STORE, data);
	};

	// 查询详情接口
	const queryDetail = (code: string, type: string) => {
		return request({
			url: API_VEHICLE_DETAIL,
			method: 'GET',
			params: {
				veh_code: code,
			},
		}).then((res: any) => {
			if (res.data && res.data.veh_code) {
				if (type === 'view') {
					emiter.emit(EVENT_VEHICLE_VIEW_CAR, res.data);
				} else if (type === 'edit') {
					emiter.emit(EVENT_VEHICLE_EDIT_CAR, res.data);
				}
			} else {
				message.error(res.errmsg || '车辆详情查询失败，请重试');
			}
		});
	};

	// 确认删除车辆
	const confirmDelete = () => {
		request({
			url: API_VEHICLE_DELETE,
			method: 'POST',
			data: {
				veh_code: data.veh_code,
			},
		}).then((res: any) => {
			// 操作成功关闭弹窗，查询列表
			if (res.errno === 0 && res.data.is_success) {
				message.success('删除成功');
				// 重新查询列表
				emiter.emit(EVENT_VEHICLE_RESEARCH);
			} else {
				message.error(res.errmsg);
			}
		});
	};

	const deleteCar = () => {
		Modal.confirm({
			centered: true,
			title: '车辆删除确认',
			okText: '确认',
			cancelText: '取消',
			content: (
				<>
					<div>确定删除该车辆？</div>
					<div>* 车辆删除用于车辆报废、已出售、所有权变更等不再运营场景</div>
				</>
			),
			onOk: confirmDelete,
		});
	};

	// 确认上、下架
	const confirmOff = () => {
		request({
			url: API_VEHICLE_EDIT_STATUS,
			method: 'POST',
			data: {
				veh_code: data.veh_code,
				status: data.status === 0 ? 1 : 0,
			},
		}).then((res: any) => {
			// 操作成功关闭弹窗，查询列表
			if (res.errno === 0 && res.data.is_success) {
				message.success('操作成功');
				// 重新查询列表
				emiter.emit(EVENT_VEHICLE_RESEARCH);
			} else {
				message.error(res.errmsg);
			}
		});
	};

	// 上下架
	const changeStatus = () => {
		Modal.confirm({
			centered: true,
			title: `确认要将该车辆状态修改为${data.status === 0 ? '下架' : '上架'}吗`,
			okText: '确认',
        	cancelText: '取消',
			onOk: confirmOff,
		});
	};

	// 编辑
	const edit = () => {
		queryDetail(data.veh_code, 'edit');
		emiter.emit(EVENT_VEHICLE_TYPE, 'edit');
	};

	// 查看
	const view = () => {
		// 获取详情
		queryDetail(data.veh_code, 'view');
		emiter.emit(EVENT_VEHICLE_TYPE, 'view');
	};

	return (
		<>
			<SPButton permissionKey="veh_detail" permission={permission} type="link" onClick={view}>
				查看
			</SPButton>
			<SPButton
				permissionKey="veh_edit_info"
				permission={permission}
				type="link"
				onClick={edit}
				hidden={data.check_status === 1}
			>
				编辑
			</SPButton>
			<SPButton permissionKey="veh_edit_store" permission={permission} type="link" onClick={exchangeStore}>
				调门店
			</SPButton>
			<SPButton permissionKey="veh_del" permission={permission} type="link" onClick={deleteCar}>
				删除
			</SPButton>
			<SPButton
				permissionKey="veh_edit_status"
				permission={permission}
				type="link"
				onClick={changeStatus}
				hidden={data.check_status !== 2}
			>
				{data.status === 0 ? '下架' : '上架'}
			</SPButton>
		</>
	);
};

interface TabsPropsType {
	enums?: any;
	permission?: any;
	listData?: any;
	encryption?: any;
}
interface TableDataType {
	store_name: string;
	model_name: string;
	series_name: string;
	brand_name: string;
	encrypt_veh_plate: string;
	status: number;
	create_time: number;
	check_status: any;
}

const SPVehicleTable: React.FC<TabsPropsType> = props => {
	const { permission, enums } = props;
	const columns: TableProps<TableDataType>['columns'] = [
		{
			title: '车牌号',
			dataIndex: 'encrypt_veh_plate',
			key: 'encrypt_veh_plate',
			width: 120,
		},
		{ title: '归属门店', dataIndex: 'store_name', key: 'store_name', width: 120 },
		{ title: '品牌', dataIndex: 'brand_name', key: 'brand_name', width: 100 },
		{ title: '车系', dataIndex: 'series_name', key: 'series_name', width: 120 },
		{ title: '车型年款', dataIndex: 'vehicle_name', key: 'vehicle_name', width: 200 },
		{
			title: '审核状态',
			dataIndex: 'check_status',
			key: 'check_status',
			render: (text, record) => _.find(enums?.f_audit_status, ['key', record.check_status])?.value,
			width: 120,
		},
		{
			title: '车辆状态',
			dataIndex: 'status',
			key: 'status',
			render: text => (text === 0 ? '上架' : '下架'),
			width: 120,
		},
		{
			title: '创建时间',
			dataIndex: 'create_time',
			key: 'create_time',
			render: text => moment(text).format('YYYY-MM-DD HH:mm:ss'),
			width: 120,
		},
		{
			title: '操作时间',
			dataIndex: 'update_time',
			key: 'update_time',
			render: text => moment(text).format('YYYY-MM-DD HH:mm:ss'),
			width: 120,
		},
		{
			title: '审核时间',
			dataIndex: 'check_time',
			key: 'check_time',
			render: (text, record) =>
				record.check_status === 2 || record.check_status === 3
					? moment(text).format('YYYY-MM-DD HH:mm:ss')
					: '',
			width: 120,
		},
		{
			title: '操作',
			key: 'action',
			fixed: 'right',
			width: 220,
			render: (_, record) => <SPVehicleTableActionBar permission={permission} data={record} />,
		},
	];
	// 列表数据
	const [listData, setListData] = useState([]);
	const [totalCount, setTotalCount] = useState(0);
	const [currentPageData, setCurrentPageData] = useState<any>({
		pageIndex: 1,
		pageSize: 10,
	});
  const dataRef = useRef({});

	// 分页改变
	const onPagination = (pagination: TablePaginationConfig) => {
		emiter.emit(
			EVENT_VEHICLE_SEARCH_LIST,
			Object.assign(dataRef.current || {}, {
				page: pagination.current,
				page_size: pagination.pageSize,
			})
		);
	};

	const loadData = (params?: any) => {
    params = Object.assign({...DEFAULT_PAGE_INFO}, {...dataRef.current}, params || {});
		request({
			url: API_VEHICLE_LIST,
			method: 'GET',
			params: {
				...params,
				veh_num_type: params && (params.veh_num_type || params.veh_num_type === 0) ? params.veh_num_type : -1,
				check_status: params && (params.check_status || params.check_status === 0) ? params.check_status : -1,
				status: params && (params.status || params.status === 0) ? params.status : -1,
				vehicle_id:
					params && params.vehicle_id && params.vehicle_id.length === 3 ? params.vehicle_id[2] : undefined,
				encrypt_veh_plate:
					params && params.encrypt_veh_plate
						? encryptTextByAES(params.encrypt_veh_plate)
						: undefined,
			},
		}).then((res: any) => {
			if (res?.data?.list && res?.data?.list.length) {
				res.data.list.forEach((item: any) => {
					if (item.encrypt_veh_plate) {
						item.encrypt_veh_plate = decryptTextByAES(item.encrypt_veh_plate);
					}
				});
			}
			setListData(res.data.list);
      dataRef.current = params
			setTotalCount(res.data.total || 0);
			setCurrentPageData({
				pageIndex: res.data.page || 1,
				pageSize: res.data.page_size || 10,
			});
		});
	};

	useEffect(() => {
		loadData({ page: 1, page_size: 10 });
	}, []);

	useEffect(() => {
		emiter.on(EVENT_VEHICLE_SEARCH_LIST, loadData);
		return () => {
			emiter.removeAllListeners(EVENT_VEHICLE_SEARCH_LIST)
		}
	}, []);

	return (
		<>
			<SPContentWrap className="page-action-bar">
				<SPVehicleActionBar permission={permission} />
			</SPContentWrap>
			<Table
				size="middle"
				scroll={{ x: '100%' }}
				columns={columns}
				dataSource={listData}
				rowKey='veh_code'
				pagination={{
					total: totalCount,
					showSizeChanger: true,
					showQuickJumper: true,
					showTotal: () => `共 ${totalCount} 条数据`,
					current: currentPageData?.pageIndex,
					pageSize: currentPageData?.pageSize,
				}}
				onChange={onPagination}
			/>
		</>
	);
};

export default SPVehicleTable;
